<script setup>
import { useRouter } from "vue-router"
import { useUserStore } from '@/store/modules/user.js'

const store = useUserStore()
const router = useRouter()
</script>

<template>
  <div class="div-container">
    <div class="w-100 row gx-5 justify-content-center buttons align-self-center">
      <div class="col-11 col-md-4">
        <button class="col-12" @click="router.push('user-activity-control')" v-if="store.User?.permissions?.is_admin || store.User?.is_headship && store.User?.permissions?.can_manage_subordinates_activities">ATRIBUIR ATIVIDADES/TAREFAS</button>
      </div>

      <div class="col-11 col-md-4">
        <button class="col-12" @click="router.push('search-users')" v-if="store.User?.permissions?.is_admin || store.User?.permissions?.can_search_users">ENCONTRAR PESSOAS</button>
      </div>
    </div>

    <div class="w-100 row gx-5 justify-content-center buttons align-self-center">
      <div class="col-11 col-md-4">
        <button class="col-12" @click="router.push('user-potential')">MEU POTENCIAL</button>
      </div>

      <div class="col-11 col-md-4">
        <button class="col-12" @click="router.push('challenges')">DESAFIOS</button>
      </div>
    </div>
  </div>
</template>

<style scoped>

  .div-container {
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    gap: 13px;
  }
  
  .btn-inactive {
    opacity: .5;
    cursor: default !important;
  }
  
  @media screen and (max-width: 767px) {
    .buttons {
      gap: 20px;
    }
  }

</style>
